<template>
    <div class="powerManagerWrap">
        <div class="mainContent">
            <div class="actionBox">
                <el-button @click="openRoleModal" type="primary" v-if="functionAddRole">添加角色 <i class="el-icon-circle-plus-outline"></i></el-button>
            </div>
            <el-table :data="roleTableData" style="width: 100%">
                <el-table-column prop="role_name" label="名称"> </el-table-column>
                <el-table-column prop="role_state" label="状态(筛选)" :filters="[{ text: '有效', value: 'y' }, { text: '无效', value: 'n' }]"
                    :filter-multiple="false" :filter-method="filterTag" filter-placement="bottom-end">
                    <template slot-scope="scope">
                        <span v-if="scope.row.role_state=='y' " class="green">有效</span>
                        <span v-if="scope.row.role_state=='n' " class="red">无效 </span>
                    </template>

                </el-table-column>
                <el-table-column prop="role_id" label="id" > </el-table-column>
                <el-table-column label="分配权限" width="280">
                    <template slot-scope="scope">
                        <div>
                            <el-button size="mini" type="primary" @click="openSettingPowerModal(scope.row)" v-if="functionAssignMenu">分配该角色可见菜单</el-button>
                            <el-button size="mini" type="success" @click="openFunctionModal(scope.row)" v-if="functionAssignFuncion">分配可用功能</el-button>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="280">
                    <template slot-scope="scope">
                        <div>
                            <el-button size="mini" type="primary" plain @click="openEditRoleModal(scope.row)" v-if="scope.row.role_state=='y'&&functionEditRole">修改</el-button>
                            <el-button size="mini" type="danger" plain @click="deleteRole(scope.row)" v-if="scope.row.role_state=='y'&&functionDeleteRole">删除</el-button>
                            <el-button size="mini" type="success" plain @click="toggleRoleStatus(scope.row)" v-if="scope.row.role_state=='n'">启用</el-button>
                        </div>

                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 添加角色名称模态框 -->
        <el-dialog title="添加新角色" :visible.sync="isShowAddRoleModal" width="30%">
            <div>
                <span class="itemSpan"> <span class="redStar">*</span> 角色名称：</span>
                <input type="text" v-model="addRoleName" placeholder="输入角色的名称">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeRoleModal">取 消</el-button>
                <el-button type="primary" @click="submitAddRoleModal">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑角色名称模态框 -->
        <el-dialog title="编辑角色" :visible.sync="isShowEditRoleModal" width="30%">
            <div>
                <span> Id:</span>
                <span>{{currentRoleObj.role_id}}</span>
            </div>
            <div>
                <span class="itemSpan"> <span class="redStar">*</span> 角色名称：</span>
                <input type="text" v-model="currentRoleObj.role_name" placeholder="输入角色的名称">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeEditRoleModal">取 消</el-button>
                <el-button type="primary" @click="submitEditRoleModal">确 定</el-button>
            </span>
        </el-dialog>
        <!--分配可见菜单模态框 -->
        <el-dialog :title="'可见菜单分配'" :visible.sync="isShowSettingRoleModal" width="30%">
            <div class="modalContent">
                <div>
                    <ul>
                        <li>
                            <span class="label">当前更改的角色：</span> <span>{{currentSettingRoleName}}</span>
                        </li>
                        <li>
                        </li>
                        <li>
                            <span class="label">获取到的arr：</span> <span>{{treeCheckedArr}}</span>
                        </li>
                    </ul>
                </div>
                <el-tree ref="tree" :data="allMenuData" :default-checked-keys="treeCheckedArr" :expand-on-click-node="false" 
                    :default-expand-all="true" :props="powerProps" node-key="menu_id" show-checkbox></el-tree>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowSettingRoleModal=false">取 消</el-button>
                <el-button type="primary" @click="submitSettingModal">确 定</el-button>
            </span>
        </el-dialog>
        <!--功能分配模态框 -->
        <el-dialog :title="'功能分配分配'" :visible.sync="isShowFunctionModal" width="30%">
            <div class="modalContent">
                <div>
                    {{currentSettingRoleName}}{{currentSettingRole}}
                    <hr>
                    {{functionTreeChecked}}
                    
                </div>
                <div>
                    <el-tree ref="treeFunction" :data="allFunctionData" :default-checked-keys="functionTreeChecked" :expand-on-click-node="false"
                        :default-expand-all="true" :props="functionProps" node-key="module_id" show-checkbox></el-tree>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowFunctionModal=false">取 消</el-button>
                <el-button type="primary" @click="submitFunctionSettingModal">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
    import {
        json,
        wordData,
        utils
    } from '@/common/common.js'
    import {
        ajaxLogin,
        api
    } from '@/common/request.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
                treeCheckedArr: [],
                functionTreeChecked:[],
                currentSettingRole: '',
                currentSettingRoleName: '',
                isShowSettingRoleModal: false,
                isShowFunctionModal:false,
                allMenuData: [],
                allFunctionData:[],
                addRoleName: '',
                isShowAddRoleModal: false,
                isShowEditRoleModal: false,
                roleTableData: [],
                currentRoleObj: {},
                powerProps: {
                    label: 'menu_name',
                    children: 'subMenu'
                },
                functionProps:{
                    label: 'module_name',
                    children: 'subModule'
                }
            }
        },
        computed: {
            functionAddRole(){
                return utils.getCurrentFunction().indexOf("role_addRole")>-1
            },
            functionEditRole(){
                return utils.getCurrentFunction().indexOf("role_editRole")>-1
            },
            functionDeleteRole(){
                return utils.getCurrentFunction().indexOf("role_deleteRole")>-1
            },
            functionAssignMenu(){
                return utils.getCurrentFunction().indexOf("role_assignMenu")>-1
            },
            functionAssignFuncion(){
                return utils.getCurrentFunction().indexOf("role_assignFunction")>-1
            },
            adminId() {
                return utils.getAdminId()
            },
            roleId() {
                return utils.getRoleId()
            },
        },
        methods: {
            filterTag(value, row) {
                return row.role_state === value;
            },
            refreshPage() {
                this.getAllRoleLists()
            },
            toggleRoleStatus(list) {
                let _this = this
                let arg = {
                    roleId: list.role_id
                }
                ajaxLogin('/admin/role/updateRoleStatus', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.$message({
                            message: "启用角色成功",
                            type: 'success',
                            duration: 1000,
                        });
                        _this.refreshPage()
                    } else {}
                }, function(res) {})
            },
            getActiveFunction(){
                let _this = this
                let arg = {
                    moduleSysId: utils.getSysId(),
                }
                ajaxLogin('/admin/system/moduleListByPid', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.allFunctionData = res.data
                    } else {}
                }, function(res) {})
            },
            getActiveMenu() {
                let _this = this
                let arg = {
                    menuSysId: utils.getSysId(),
                }
                ajaxLogin('/admin/menu/menuList', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.allMenuData = res.data
                    } else {}
                }, function(res) {})
            },
            submitFunctionSettingModal(){
                if (!confirm('确认重新分配角色 “ ' + this.currentSettingRoleName + ' ” 的功能吗')) {
                    return false
                }
                let _this = this
                let newCheckedArr = _this.$refs.treeFunction.getCheckedKeys()
                let arg = {
                    createAdminId: _this.adminId,
                    roleId: _this.currentSettingRole,
                    moduleId: newCheckedArr.join(","),
                    permissionType: 'module',
                    sysId:utils.getSysId()
                }
                console.log(arg)
                ajaxLogin('/admin/role/addRoleModulePermission', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.$message({
                            message: "分配功能成功",
                            type: 'success',
                            duration: 1000,
                        });
                        _this.isShowFunctionModal = false
                    } else {
                        _this.$message({
                            message: res.errorMsg,
                            type: 'error',
                        });
                    }
                }, function(res) {})
            },
            submitSettingModal() { //分配角色提交  "createAdminId":"1","roleId":"2","moduleId":"7,5,6","permissionType":"module"
                if (!confirm('确认修改角色 “ ' + this.currentSettingRoleName + ' ” 可见菜单吗')) {
                    return false
                }

                let _this = this
                let newCheckedArr = _this.$refs.tree.getCheckedKeys()
                let arg = {
                    createAdminId: _this.adminId,
                    roleId: _this.currentSettingRole,
                    menuId: newCheckedArr.join(","),
                    permissionType: 'menu',
                    sysId:utils.getSysId()
                }
                ajaxLogin('/admin/role/addRolePermission', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.$message({
                            message: "设置菜单成功",
                            type: 'success',
                            duration: 1000,
                        });
                        _this.isShowSettingRoleModal = false
                    } else {
                        _this.$message({
                            message: res.errorMsg,
                            type: 'error',
                        });
                    }
                }, function(res) {})

            },
            setCheckedKeys() {
                let _this = this
                this.$refs.tree.setCheckedKeys(_this.treeCheckedArr);
            },
            setCheckedKeys_function() {
                let _this = this
                this.$refs.treeFunction.setCheckedKeys(_this.functionTreeChecked);
            },
            getCheckedDataIdArr(menuArr) {
                let _this = this
                let result = []
                if (!menuArr || menuArr.length == 0) {
                    return result
                } else {
                    menuArr.forEach(function(item, index) {
                        let bufferId = item.menu_id
                        console.log(bufferId)
                        if (item.subMenu && item.subMenu.length > 0) {
                            let childrenIDArr = _this.getCheckedDataIdArr(item.subMenu)
                            console.log(bufferId + "有子元素，：" + childrenIDArr)
                            result = result.concat(childrenIDArr)
                        } else {
                            result.push(bufferId)
                            console.log(bufferId + "没有子元素")

                        }
                    })
                    return result
                }
            },
            getCheckedDataIdArr_function(menuArr) {
                let _this = this
                let result = []
                if (!menuArr || menuArr.length == 0) {
                    return result
                } else {
                    menuArr.forEach(function(item, index) {
                        let bufferId = item.module_id
                        if (item.subModule && item.subModule.length > 0) {
                            let childrenIDArr = _this.getCheckedDataIdArr_function(item.subModule)
                            result = result.concat(childrenIDArr)
                        } else {
                            result.push(bufferId)
            
                        }
                    })
                    return result
                }
            },
            openSettingPowerModal(list) {//打开菜单模态框，把已勾选的菜单放进去
                let _this=this
                console.log(list)
                _this.currentSettingRole=list.role_id//当前设置权限d的角色
                _this.currentSettingRoleName=list.role_name
                _this.isShowSettingRoleModal=true
                let arg={
                    permissionType:'menu',
                    roleId:list.role_id
                }
                //ajax获取已经选中的数据,当前角色拥有的权限
                _this.treeCheckedArr=[]
                ajaxLogin('/admin/menu/showUserRoleList',arg).then(function(res){
                    if(res.errorCode==200){
                        _this.treeCheckedArr=_this.getCheckedDataIdArr(res.data)
                        console.log( _this.treeCheckedArr,'重置编辑框的选中数据,获取到的已有的菜单')
                        _this.setCheckedKeys()
                    }else{
                         _this.setCheckedKeys()
                    }
                },function(res){
                      _this.setCheckedKeys()
                })
            },
            openFunctionModal(list){//打开功能分配的模态框
                let _this = this
                console.log(list)
                _this.currentSettingRole = list.role_id //当前设置权限d的角色
                _this.currentSettingRoleName = list.role_name
                _this.isShowFunctionModal = true
                let arg = {
                    permissionType: 'module',
                    roleId: list.role_id ,  
                    sysId:utils.getSysId()
                }
                _this.functionTreeChecked=[]
                ajaxLogin('/admin/system/showUserRoleModuleList',arg).then(function(res){
                    if(res.errorCode==200){
                        _this.functionTreeChecked=_this.getCheckedDataIdArr_function(res.data)
                        console.log( _this.functionTreeChecked,'重置编辑框的选中数据,获取到的已有的权限')
                        _this.setCheckedKeys_function()
                    }else{
                        _this.setCheckedKeys_function()
                    }
                },function(res){
                    _this.setCheckedKeys_function()
                })
            },
            deleteRole(list) {
                let _this = this
                if (!confirm("确认删除 ' " + list.role_name + " ' 吗？")) {
                    return false
                }
                let arg = {
                    roleId: list.role_id
                }
                ajaxLogin('/admin/role/delRoleByRid', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.$message({
                            message: "删除成功",
                            type: 'success',
                            duration: 1000,
                        });
                        _this.refreshPage()
                    } else {
                        _this.$message({
                            message: res.errorMsg,
                            type: 'error',
                        });
                    }
                }, function(res) {})
            },
            openEditRoleModal(list) {
                this.isShowEditRoleModal = true
                this.currentRoleObj = JSON.parse(JSON.stringify(list))
            },
            submitEditRoleModal() {
                let _this = this
                console.log(_this.currentRoleObj)
                if (!_this.currentRoleObj.role_name) {
                    _this.$message({
                        message: "角色名称必填",
                        type: 'error',
                    });
                } else {
                    let arg = {
                        roleName: _this.currentRoleObj.role_name,
                        roleId: _this.currentRoleObj.role_id
                    }
                    ajaxLogin('/admin/role/editRole', arg).then(function(res) {
                        if (res.errorCode == 200) {
                            _this.$message({
                                message: "修改成功",
                                type: 'success',
                                duration: 1000
                            });
                            _this.closeEditRoleModal()
                            _this.refreshPage()
                        } else {
                            _this.$message({
                                message: res.errorMsg,
                                type: 'error',
                            });
                        }
                    }, function(res) {})
                }
            },
            submitAddRoleModal() {
                let _this = this
                if (!_this.addRoleName) {
                    _this.$message({
                        message: "未填写角色名称",
                        type: 'error',
                    });
                } else {
                    let arg = {
                        roleName: _this.addRoleName,
                        roleSysId: utils.getSysId()
                    }
                    ajaxLogin('/admin/role/addRole', arg).then(function(res) {
                        if (res.errorCode == 200) {
                            _this.$message({
                                message: "添加成功",
                                type: 'success',
                                duration: 1000
                            });
                            _this.closeRoleModal()
                            _this.refreshPage()
                        } else {
                            _this.$message({
                                message: res.errorMsg,
                                type: 'error',
                            });
                        }
                    }, function(res) {})
                }
            },
            openRoleModal() {
                this.isShowAddRoleModal = true
            },
            closeEditRoleModal() {
                this.isShowEditRoleModal = false
            },
            closeRoleModal() {
                this.isShowAddRoleModal = false
                this.addRoleName = ''
            },
            getActiveRoleLists() {
                let _this = this
                let arg = {}
                ajaxLogin('/admin/role/roleList', arg).then(function(res) {}, function(res) {})

            },
            getAllRoleLists() {
                let _this = this
                let arg = {
                    "roleSysId": utils.getSysId()
                }
                ajaxLogin('/admin/role/getAllRoleList', arg).then(function(res) {
                    _this.roleTableData = res.data
                }, function(res) {})

            },
        },
        mounted() {
            this.getAllRoleLists()
            this.getActiveMenu()
            this.getActiveFunction()
        }
    }
</script>

<style scoped lang="scss">
    // *{outline:1px solid red}
    .powerManagerWrap {
        input {
            border: 1px solid #999;
            border-radius: 6px;
            padding: 10px;
        }

        .mainContent {
            padding: 0px 10px 40px 10px;
        }

        .actionBox {
            padding: 10px 0;
        }

    }
</style>



// WEBPACK FOOTER //
// src/pages/system/roleManager.vue